export default __webpack_public_path__ + "static/media/icon-beat-heat.32b201e3.gif";